<!--
 分页组件
  -->
<template>
  <el-pagination class="page-box"
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange"
                 background :current-page="childMsg.currentNum"
                 :page-sizes="[10, 25,50,100]"
                 :page-size="childMsg.pageSize"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="childMsg.total">
  </el-pagination>
</template>
<script>
export default {
  name: 'Pagination',
  /**
   * childMsg: {
   *      currentNum
   *      pageSize
   *      total
   * }
   *
   * */
  props: ['childMsg'],
  data () {
    return {
      page: {
        currentNum: this.childMsg.currentNum,
        pageSize: this.childMsg.pageSize
      }
    }
  },
  created () {
  },
  methods: {
    handleSizeChange (val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.page.pageSize = val
      this.$emit('callFather', this.page)
    },
    handleCurrentChange (val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.page.currentNum = val
      this.$emit('callFather', this.page)
    }
  }
}
</script>

<style scoped>
.page-box {
  margin: 10px auto;
}
</style>
